import { render } from "./PropertyList.vue?vue&type=template&id=abbc16a6&scoped=true&ts=true"
import script from "./PropertyList.vue?vue&type=script&lang=ts"
export * from "./PropertyList.vue?vue&type=script&lang=ts"

import "./PropertyList.vue?vue&type=style&index=0&id=abbc16a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abbc16a6"]])

export default __exports__